import {router} from "@/router/index.js";
import store from "@/store/index.js";
import request from '@/utils/request.js'
import {ElMessage} from "element-plus";

const user = {
    namespaced:true,
    state: {
        username:'',
        password:'',
        remember:false,
        company:'',
        token: null,
        menus: [],
        user_info:null,
        is_login: false
    },
    getters: {
        getMenus: (state) => {
            let menus = state.menus;
            if(!menus || menus.length <= 0){
                let menusStr = localStorage.getItem('menus');
                menus = menusStr != null && menusStr.length > 0 ? JSON.parse(menusStr) : [];
            }
            return menus;
        },
        getUserInfo: (state) => {
            let userInfo = state.user_info;
            //alert(state.token)
            //console.log('-------------------getUserInfo：',state.token)
            if(userInfo == null){
                let userInfoStr = localStorage.getItem('user');
                userInfo = userInfoStr != null && userInfoStr.length > 0 ? JSON.parse(userInfoStr) : null;
            }

            return userInfo;
        },
        getToken:(state)=>{
            let token = state.token;
            // console.log('state 中的token：',token);
            if(!token || token.length <= 0){
                token = localStorage.getItem('token');
               // console.log('localStorage 中的token：',token);
            }
            return token;
        }
    },
    mutations: {
        updateUser: (state, user) => {
            state.user_info = {
                uuid:user.uuid,
                username:user.username,
                total_value:user.total_value,
                company:user.company,
                nickname:user.nickname,
                avatar:!user.head_image ? user.head_image : '',
                is_login:true,
                remember:user.remember
            }
            if(user.remember === true){
                state.user_info.password = user.password;
            }
            state.token = user.token;
            //alert(state.user_info.username)
        },
        updateMenu: (state, menus) => {
            if(!menus && menus.length > 0){
                state.menus = [...menus];
                localStorage.setItem('menus',JSON.stringify(menus))
            }
        },
        logout: (state) => {
            let userInfo = state.user_info;
            if(userInfo == null){
                let userInfoStr = localStorage.getItem('user');
                userInfo = userInfoStr != null && userInfoStr.length > 0 ? JSON.parse(userInfoStr) : null;
            }

            const rememberAccount = userInfo != null && userInfo.remember === true;

            if(rememberAccount){
                state.user_info = {
                    username: userInfo.username,
                    password:userInfo.password,
                    remember:rememberAccount
                }
                localStorage.setItem('user',JSON.stringify(state.user_info));
            }
            else{
                state.user_info = null;
                localStorage.removeItem('user');
            }

            localStorage.removeItem('token');
            localStorage.removeItem('menus');

            state.menus = null;
            state.token = '';
            router.replace('/login');
        }
    },
    actions: {
        login: async (context, data) => {
           await request.post('/passport/login',data).then(res=>{
               //console.log('-----data：',data);
               if(res.code === 0){
                   const user = {
                       username: res.data.username,
                       nickname: res.data.nickname,
                       avatar: res.data.avatar,
                       total_value: res.data.total_value,
                       uuid: res.data.uuid,
                       company: res.data.company,
                       token: res.data.token,
                       remember:data.remember,
                       password:data.password
                   };
                   context.commit('updateUser',user);
                   localStorage.setItem('user', JSON.stringify(user))
                   localStorage.setItem('token', user.token)
                   ///location.href = '/'
                   router.replace('/')
               }else{
                   ElMessage({
                       message:res.msg,
                       type: 'error',
                       plain: true,
                   })
               }
           });
        },
        getMenusInfo: (context) => {
            let menusStr = localStorage.getItem('menus');
            let menus = menusStr != null && menusStr.length > 0 ? JSON.parse(menusStr) : [];
            if(!menus || menus.length <= 0){
               // menus = [];
                context.commit('updateMenu', menus);
            }
            return menus;
        }
    }
}

export default user;